import styled from '@emotion/styled';
import { tokens, Button } from '@hotjar/hotsauce';

export const ProductSelectActionsStyles = {
  BookACallButton: styled(Button)`
    margin-left: ${tokens.spacer.x2};
  `,
};
